import DataModel from '../model/DataModel';

export default class PropertySheetDataModel extends DataModel {
  constructor() {
    super();

    this.createEvent('submitChanges');
    this.createEvent('revertChanges');
    
    this.isModified = false;
    this.hasErrors = false;
  }
}